import clsx from 'clsx';
import React, { ComponentProps } from 'react';
import { SanityBlock, SanityLink, SanityProductItem } from '../../../../graphql-types';
import { Typography } from '../atoms/typography';
import { RichText } from '../molecules/rich-text';
import { Container } from '../atoms/container';
import { SanityLinkList } from '../molecules/sanity-link-list';
import { Carousel } from '../molecules/carousel';
import { ProductCard } from '../../ProductCard';

type TitleSize = 'default' | 'large';

type ProductCarouselBlockProps = {
    titleSize?: TitleSize;
    className?: string;
    title: string;
    description?: SanityBlock[];
    links?: SanityLink[];
    productList?: SanityProductItem[];
};

export function ProductCarouselBlock({
    title,
    description,
    titleSize = 'default',
    links,
    productList,
    className,
}: ProductCarouselBlockProps) {
    return (
        <Container className={className}>
            {title || description ? (
                <div className={clsx('mb-6 lg:mb-8')}>
                    <Typography
                        variant={titleSize === 'large' ? 'hd-3xl' : 'hd-lg'}
                        desktopVariant={titleSize === 'large' ? 'hd-4xl' : 'hd-lg'}
                        as="h2"
                    >
                        {titleSize === 'large' ? title : <strong>{title}</strong>}
                    </Typography>
                    {description ? (
                        <RichText
                            value={description}
                            className={clsx({
                                'mt-3 md:mt-4 lg:mt-6': !!title,
                            })}
                        />
                    ) : null}

                    {links && links.length > 0 ? (
                        <SanityLinkList links={links} size="md" className="mt-8" />
                    ) : null}
                </div>
            ) : null}

            <Carousel
                slides={productList?.map((item, index) => {
                    if (!item) {
                        return null;
                    }

                    return (
                        <div
                            className={clsx(
                                'px-2 md:px-3 lg:px-4 xl:px-8 w-2/3 md:w-2/5 lg:w-1/3  shrink-0',
                                {
                                    'lg:w-2/5': productList.length > 3,
                                }
                            )}
                            key={index}
                        >
                            <ProductCard
                                productCard={
                                    item as ComponentProps<typeof ProductCard>['productCard']
                                }
                                imgSizes="100vw"
                            />
                        </div>
                    );
                })}
            >
                {({ carousel }) => {
                    return <div className="-mx-2 md:-mx-3 lg:-mx-4 xl:-mx-8">{carousel}</div>;
                }}
            </Carousel>
        </Container>
    );
}
